import React, { useEffect } from 'react';
import {
  BrowserRouter,
  Switch,
  Route,
} from 'react-router-dom';
import './main.scss';
import { UserProvider } from './hooks/UserContext';
import socket from './helpers/socket-connect';
import SecureRoute from './pages/SecureRoute';

/*
  Components
*/
import Header from './components/Header';
import Footer from './components/Footer';

/*
  Views
*/
import Home from './views/Home';
import Checklists from './views/Checklists';
import TodoList from './views/TaskList';
import NotFound from './views/NotFound';
import Signup from './views/Register';
import Login from './views/Login';

const App = () => {
  useEffect(() => {
    socket.on('connect', () => {
      // console.log(socket.id);
    });
    // socket.on('connect_error', (err: any) => {
    //   // console.log(err.message);
    // });
    socket.on('disconnect', () => {
      // console.log(socket.id);
    });
    /*

    Mouse mouvements code to be finished

    const intervalId = setInterval(() => {
      window.onmousemove = (e: any) => {
        socket.emit('mouse', {mx: e.clientX, my: e.clientY});
      };
    }, 1000);

    */
    return () => {
      socket.close();
      // clearInterval(intervalId);
    };
  }, []);

  return (
    <BrowserRouter>
      <UserProvider>
        <Header />
        <main className="main">
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <SecureRoute path="/checklists/:checklistId" component={TodoList} />
            <SecureRoute path="/checklists" component={Checklists} />
            <Route path="/" component={NotFound} />
          </Switch>
        </main>
        <Footer />
      </UserProvider>
    </BrowserRouter>
  );
};

export default App;
